import '.ab{position:relative;}.ssr-plugin'
import '.kx{width:64px;}.ssr-plugin'
import '.ky{height:64px;}.ssr-plugin'
import '.ae{flex-shrink:0;}.ssr-plugin'
import '.bi{position:absolute;}.ssr-plugin'
import '.kz{bottom:-4px;}.ssr-plugin'
import '.j6{right:-4px;}.ssr-plugin'
import '.gt{border-radius:50%;}.ssr-plugin'
import '.ck{border:2px solid var(--palette-white);}.ssr-plugin'
import '.b3{overflow:hidden;}.ssr-plugin'
import '.l0{width:32px;}.ssr-plugin'
import '.l1{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'
import { StoredImage } from '@app/types/StoredImage'

type ConversationAvatarProps = {
  initiativeImage?: StoredImage
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  const hasImage = !!initiativeImage && !!initiativeImage.src
  return (
    <div className="ab kx ky ae"
    >
      {hasImage ? (
        <Image
          src={initiativeImage.src}
          alt={initiativeImage.altText || 'initiative image'}
          resizeWidth={128}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="bi kz j6 gt ck b3 l0 l1"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
